/**
 * Página de Relatórios
 * Exibe relatórios financeiros e gráficos
 */

import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
} from '@mui/material';
import { PictureAsPdf as PdfIcon } from '@mui/icons-material';

/**
 * Página de Relatórios
 */
const Relatorios = () => {
  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">
          Relatórios
        </Typography>
        <Button
          variant="contained"
          startIcon={<PdfIcon />}
          onClick={() => alert('Exportação de PDF será implementada')}
        >
          Exportar PDF
        </Button>
      </Box>

      <Grid container spacing={3}>
        {/* Resumo Financeiro */}
        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Resumo Financeiro - Novembro 2025
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Typography variant="body1" gutterBottom>
                <strong>Faturamento Total:</strong> R$ 45.000,00
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Despesas Totais:</strong> R$ 18.000,00
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Lucro Líquido:</strong> R$ 27.000,00
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Margem de Lucro:</strong> 60%
              </Typography>
            </Box>
          </Paper>
        </Grid>

        {/* Gráfico de Despesas por Categoria */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '300px' }}>
            <Typography variant="h6" gutterBottom>
              Despesas por Categoria
            </Typography>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="80%"
            >
              <Typography color="text.secondary">
                Gráfico de pizza será implementado aqui
              </Typography>
            </Box>
          </Paper>
        </Grid>

        {/* Gráfico de Faturamento Mensal */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '300px' }}>
            <Typography variant="h6" gutterBottom>
              Faturamento Mensal
            </Typography>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="80%"
            >
              <Typography color="text.secondary">
                Gráfico de barras será implementado aqui
              </Typography>
            </Box>
          </Paper>
        </Grid>

        {/* Principais Despesas */}
        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Principais Despesas
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" gutterBottom>
                1. Aluguel - R$ 9.000,00 (50%)
              </Typography>
              <Typography variant="body2" gutterBottom>
                2. Materiais - R$ 5.000,00 (28%)
              </Typography>
              <Typography variant="body2" gutterBottom>
                3. Equipamentos - R$ 4.000,00 (22%)
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Relatorios;
